import { ReactNode } from "react";
import { CheckCircle2Icon, CircleIcon } from "lucide-react";

interface SettingItemProps {
  label: string;
  enabled: boolean;
}

function SettingItem({ label, enabled }: SettingItemProps) {
  return (
    <div className="flex items-center gap-2">
      {enabled ? (
        <CheckCircle2Icon className="text-primary h-5 w-5" />
      ) : (
        <CircleIcon className="text-muted-foreground h-5 w-5" />
      )}
      <span className="text-foreground text-sm font-medium">{label}</span>
    </div>
  );
}

interface SettingsCardProps {
  children: ReactNode;
}

export function SettingsCard({ children }: SettingsCardProps) {
  return <div className="flex flex-wrap items-center gap-4">{children}</div>;
}

SettingsCard.Item = SettingItem;
